module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE4MSIgdmlld0JveD0iMCAwIDMwMSAxODEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDBBMURFIiBkPSJNLjUgOTAuNWgzMDB2OTBILjV6Ii8+PHBhdGggZmlsbD0iI0VEMjkzOSIgZD0iTS41LjVoMzAwdjkwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0uNSA2MC41aDMwMHY2MEguNXoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-lu.svg
// module id = +ZdV
// module chunks = 2